import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_CalendarManagementDetailForm = _resolveComponent("CalendarManagementDetailForm")
  const _component_CalendarManagementDetailTable = _resolveComponent("CalendarManagementDetailTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "calendar-management-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    visible: _ctx.visible,
    modal: true,
    closable: false,
    style: _ctx.calendarManagementDialogDescriptor.dialog.style
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.calendar?.calendar), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.close
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.canManageCalendar)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--primary",
            disabled: _ctx.buttonDisabled,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar"
          }))
        : _createCommentVNode("", true),
      _createVNode("div", null, [
        _createVNode(_component_CalendarManagementDetailForm, {
          propCalendar: _ctx.calendar,
          generateButtonVisible: _ctx.generateButtonVisible,
          generateButtonDisabled: _ctx.generateButtonDisabled,
          onGenerateCalendarClicked: _ctx.generateCalendarConfirm
        }, null, 8, ["propCalendar", "generateButtonVisible", "generateButtonDisabled", "onGenerateCalendarClicked"]),
        (_ctx.calendarDetailTableVisible)
          ? (_openBlock(), _createBlock(_component_CalendarManagementDetailTable, {
              key: 0,
              class: "p-m-4",
              propCalendarInfo: _ctx.calendar?.splittedCalendar,
              domains: _ctx.domains
            }, null, 8, ["propCalendarInfo", "domains"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible", "style"]))
}